import { IMedicalState, IGetMedicalArgs, IGetMedicalPayload } from '../types';
import { REPLY_MEDICAL } from '../constants';
import medicalServices from '../medicalServices';
import { createAsyncThunk, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { medicalActions } from '.';

export const replyMedical = createAsyncThunk<
  any,
  { id: number; content: string },
  ThunkAPIConfig
>(REPLY_MEDICAL, async (args, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await medicalServices.replyMedical(args.id, args.content);
    dispatch(
      medicalActions.getMedicals({
        page: 1,
        limit: 10
      })
    );
    return {
      data
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const replyMedicalBuilder = (
  builder: ActionReducerMapBuilder<IMedicalState>
) => {
  const { pending, fulfilled, rejected } = replyMedical;
  builder
    .addCase(pending, draftState => {
      draftState.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      const { data } = action.payload;
      draftState.loading = false;
      draftState.backList = true;
    })
    .addCase(rejected, draftState => {
      draftState.loading = false;
    });
};
